import { Color } from '../tokentypes';
import { fromConst, fromNestedArguments } from './base';
function createColor(rawData) {
  return new Color(rawData);
}
function createOptionalColor(rawData) {
  if (!rawData) {
    return null;
  }
  return new Color(rawData);
}
export function colorConst(rawData, tokenOptions) {
  return fromConst(createColor, rawData, tokenOptions);
}
export function colorTokenFromNestedArguments(rawData, argList, tokenOptions) {
  return fromNestedArguments(createColor, rawData, argList, tokenOptions);
}
export function optionalColorConst(rawData, tokenOptions) {
  return fromConst(createOptionalColor, rawData, tokenOptions);
}
export function optionalColorTokenFromNestedArguments(rawData, argList, tokenOptions) {
  return fromNestedArguments(createOptionalColor, rawData, argList, tokenOptions);
}
//# sourceMappingURL=colors.js.map